import * as React from "react";

import {PropertyPlanIcon} from "@pg-design/icons-module";

interface IOwnProps {
    onPlanClick: (e: React.MouseEvent<HTMLElement>, index: number) => void;
    index: number;
}

export const PropertyListPlanButton: React.FC<IOwnProps> = (props: IOwnProps) => {
    const stopPropagation = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
    };

    return (
        <div onClick={stopPropagation}>
            {props.onPlanClick ? (
                <div>
                    <span onClick={(e) => props.onPlanClick(e, props.index)}>
                        <PropertyPlanIcon size="2" />
                    </span>
                </div>
            ) : (
                <a href="property.plan">
                    <PropertyPlanIcon size="2" />
                </a>
            )}
        </div>
    );
};
import * as React from "react";

import {PropertyPlanIcon} from "@pg-design/icons-module";

interface IOwnProps {
    onPlanClick: (e: React.MouseEvent<HTMLElement>, index: number) => void;
    index: number;
}

export const PropertyListPlanButton: React.FC<IOwnProps> = (props: IOwnProps) => {
    const stopPropagation = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
    };

    return (
        <div onClick={stopPropagation}>
            {props.onPlanClick ? (
                <div>
                    <span onClick={(e) => props.onPlanClick(e, props.index)}>
                        <PropertyPlanIcon size="2" />
                    </span>
                </div>
            ) : (
                <a href="property.plan">
                    <PropertyPlanIcon size="2" />
                </a>
            )}
        </div>
    );
};
